/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Batch_Pick_Preset_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Select a preset…" |
*
* @param {Explorer_Info_Batch_Pick_Preset_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_pick_preset_placeholder = /** @type {((inputs?: Explorer_Info_Batch_Pick_Preset_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Pick_Preset_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez un préréglage…")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie eine Voreinstellung…")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un'impostazione predefinita…")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите предустановленный параметр…")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione un ajuste preestablecido…")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择预设…")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリセットを選択してください…")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक प्रीसेट चुनें…")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione uma predefinição…")
	return /** @type {LocalizedString} */ ("Select a preset…")
});